export default "/images/36973cd4f17969b45f166875c1a83ad9.png";